import { BRAND } from "@/lib/data";

/**
 * Build a formatted enquiry message from form values (or a plain string).
 * Used by both WhatsApp (wa.me) and Email (mailto:) senders so the message
 * body is identical regardless of channel.
 */
export function buildEnquiryMessage(payload) {
    if (typeof payload === "string") return payload;
    if (!payload || typeof payload !== "object") return "";
    const {
        fullName,
        country,
        email,
        phone,
        enquiryType,
        interestedIn,
        budget,
        message,
    } = payload;
    const lines = [
        "Hello The Treasure Threads,",
        "",
        "I would like to enquire about your collection.",
        "",
        fullName ? `Name: ${fullName}` : null,
        country ? `Country: ${country}` : null,
        email ? `Email: ${email}` : null,
        phone ? `Phone: ${phone}` : null,
        enquiryType ? `Enquiry Type: ${enquiryType}` : null,
        interestedIn ? `Interested in: ${interestedIn}` : null,
        budget ? `Budget: ${budget}` : null,
        message ? `\nMessage:\n${message}` : null,
        "",
        "Thank you.",
    ].filter(Boolean);
    return lines.join("\n");
}

// Build a wa.me URL with a pre-filled message.
export function buildWhatsAppUrl(payload) {
    const text = buildEnquiryMessage(payload);
    const encoded = encodeURIComponent(text);
    return `https://wa.me/${BRAND.phoneRaw}?text=${encoded}`;
}

// Build a mailto: URL with subject + body.
export function buildMailtoUrl(payload) {
    const body = buildEnquiryMessage(payload);
    const enquiryType = payload && typeof payload === "object" ? payload.enquiryType : "";
    const interestedIn = payload && typeof payload === "object" ? payload.interestedIn : "";
    const subjectParts = [
        `${enquiryType ? enquiryType + " " : ""}Enquiry`.trim(),
        interestedIn ? `— ${interestedIn}` : "",
    ].filter(Boolean);
    const subject = subjectParts.join(" ") || "Enquiry";
    return `mailto:${BRAND.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
